import Upload from './upload';
import './styles/index.scss';
export default Upload;
